__turbopack_context__.v({
  "content": "tooltip-module-scss-module__0KJTaW__content",
  "tooltip": "tooltip-module-scss-module__0KJTaW__tooltip",
});
